"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./ButtonGroup.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styles = require("../../styles");

var _utils = require("../../utils");

var _Icons = require("../Icons");

var _InputErrorMessage = require("../Inputs/InputErrorMessage");

var _InputErrorMessage2 = _interopRequireDefault(_InputErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var className = 'c-ButtonGroup';
var buttonClassName = "".concat(className, "__button");

var ButtonGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ButtonGroup, _PureComponent);

  function ButtonGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ButtonGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      selected: ''
    };

    _this.onButtonClick = function (e) {
      var value = e.currentTarget.value;

      _this.props.onClick(_this.checkType(value));

      _this.setState({
        selected: value
      });
    };

    _this.getErrorClassName = function () {
      return _this.props.error && _this.props.spaceBetween ? "".concat(className, "--error-buttonGroup") : '';
    };

    _this.getGroupClassName = function () {
      return [className, _this.props.spaceBetween ? "".concat(className, "--space-between") : '', _this.props.error && !_this.props.spaceBetween ? "".concat(className, "--error") : '', _this.getErrorClassName()].filter(Boolean).join(' ');
    };

    _this.getIconClassName = function (option) {
      if (option.icon.toString() === "two_people" || option.icon.toString() === "person_children" || option.icon.toString() === "couple_children") return "".concat(className, "__widerIcon");else return "".concat(className, "__icon");
    };

    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!(this.props.selected === null || this.props.selected === undefined)) {
        this.setState({
          selected: this.props.selected
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selected !== this.props.selected) this.setState({
        selected: this.props.selected
      });
    }
  }, {
    key: "checkBoolean",
    value: function checkBoolean(value) {
      if (value === 'true') {
        return true;
      } else if (value === 'false') {
        return false;
      }

      return value;
    }
  }, {
    key: "checkType",
    value: function checkType(value) {
      switch (this.props.valueType) {
        case 'boolean':
          return this.checkBoolean(value);

        case 'number':
          return Number(value);

        case 'string':
        default:
          return value;
      }
    }
  }, {
    key: "getButtonClassNames",
    value: function getButtonClassNames(value) {
      return [buttonClassName, this.props.disabled ? "".concat(buttonClassName, "--disabled") : '', this.props.largerButton ? "".concat(buttonClassName, "--largerButton") : '', value.toString() === this.state.selected.toString() ? "".concat(buttonClassName, "--selected") : ''].filter(Boolean).join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          options = _this$props.options,
          disabled = _this$props.disabled,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage;
      var color = _styles.colors.primaryColor;
      var selectedColor = _styles.colors.bgLightestColor;
      var icons = {
        home: _react2.default.createElement(_Icons.HomeIcon, {
          color: color
        }),
        sun: _react2.default.createElement(_Icons.SunIcon, {
          color: color
        }),
        key: _react2.default.createElement(_Icons.KeyIcon, {
          color: color
        }),
        hand: _react2.default.createElement(_Icons.HandIcon, {
          color: color
        }),
        plane: _react2.default.createElement(_Icons.PlaneIcon, {
          color: color
        }),
        planes: _react2.default.createElement(_Icons.PlanesIcon, {
          color: color
        }),
        globe_europe: _react2.default.createElement(_Icons.GlobeEuropeIcon, {
          color: color
        }),
        globe_americas: _react2.default.createElement(_Icons.GlobeAmericasIcon, {
          color: color
        }),
        one_person: _react2.default.createElement(_Icons.PersonOneIcon, {
          color: color
        }),
        two_people: _react2.default.createElement(_Icons.PersonTwoIcon, {
          color: color
        }),
        person_children: _react2.default.createElement(_Icons.PersonChildrenIcon, {
          color: color
        }),
        couple_children: _react2.default.createElement(_Icons.PeopleChildrenIcon, {
          color: color
        })
      };
      var selectedIcons = {
        home: _react2.default.createElement(_Icons.HomeIcon, {
          color: selectedColor
        }),
        sun: _react2.default.createElement(_Icons.SunIcon, {
          color: selectedColor
        }),
        key: _react2.default.createElement(_Icons.KeyIcon, {
          color: selectedColor
        }),
        hand: _react2.default.createElement(_Icons.HandIcon, {
          color: selectedColor
        }),
        plane: _react2.default.createElement(_Icons.PlaneIcon, {
          color: selectedColor
        }),
        planes: _react2.default.createElement(_Icons.PlanesIcon, {
          color: selectedColor
        }),
        globe_europe: _react2.default.createElement(_Icons.GlobeEuropeIcon, {
          color: selectedColor
        }),
        globe_americas: _react2.default.createElement(_Icons.GlobeAmericasIcon, {
          color: selectedColor
        }),
        one_person: _react2.default.createElement(_Icons.PersonOneIcon, {
          color: selectedColor
        }),
        two_people: _react2.default.createElement(_Icons.PersonTwoIcon, {
          color: selectedColor
        }),
        person_children: _react2.default.createElement(_Icons.PersonChildrenIcon, {
          color: selectedColor
        }),
        couple_children: _react2.default.createElement(_Icons.PeopleChildrenIcon, {
          color: selectedColor
        })
      };
      return _react2.default.createElement("div", {
        className: "".concat(className, "__buttonGroupContainer")
      }, _react2.default.createElement(_InputErrorMessage2.default, {
        id: "".concat(name, "ErrorMessage"),
        error: error,
        errorMessage: errorMessage
      }), _react2.default.createElement("div", {
        className: this.getGroupClassName(),
        id: name,
        role: "radiogroup"
      }, options.map(function (option) {
        return _react2.default.createElement("button", {
          key: "button-group-button-".concat(option.label),
          id: "".concat(name, "__").concat(option.label),
          name: option.value.toString(),
          disabled: disabled,
          tabIndex: 0,
          onClick: _this2.onButtonClick,
          type: "button",
          className: _this2.getButtonClassNames(option.value),
          value: option.value,
          role: "radio",
          onBlur: onBlur
        }, option.icon ? _react2.default.createElement("div", {
          className: _this2.getIconClassName(option)
        }, option.value.toString() === _this2.state.selected.toString() ? selectedIcons[option.icon] : icons[option.icon]) : _react2.default.createElement(_react2.default.Fragment, null), _react2.default.createElement("div", {
          className: "".concat(className, "__label")
        }, option.label));
      })));
    }
  }]);

  return ButtonGroup;
}(_react.PureComponent);

ButtonGroup.defaultProps = {
  options: [],
  disabled: false,
  onClick: _utils.noop,
  spaceBetween: true,
  valueType: 'string',
  selected: '',
  largerButton: false
};
exports.default = ButtonGroup;